import { Box, Button, Typography, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, LinearProgress } from '@mui/material';
import React, { useContext, useState } from 'react';

import AnnonceContext from '../../../../contexts/AnnonceContext';
import BoxSelector from './Forms/BoxSelector';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function Step5() {
  const { handleSubmit, formAnnonce, resetForm, isSubmitting, uploadProgress } = useContext(AnnonceContext);
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  
  // Vérifier si une boîte est sélectionnée
  const isBoxSelected = formAnnonce.stockage && formAnnonce.stockage.trim() !== '';

  const handlePublish = async () => {
    if (isSubmitting || isPublished) {
      console.log('Publication déjà en cours ou terminée, ignoré');
      return;
    }
    
    try {
      setIsPublished(true);
      await handleSubmit();
    } catch (error) {
      console.error('Erreur lors de la publication:', error);
      setIsPublished(false); // Remettre à false en cas d'erreur
    }
  };

  const handleCancelClick = () => {
    setShowCancelDialog(true);
  };

  const handleCancelConfirm = () => {
    // Réinitialiser complètement le formulaire
    resetForm();
    setShowCancelDialog(false);
  };

  const handleCancelClose = () => {
    setShowCancelDialog(false);
  };

  return (
    <>
     {
      formAnnonce.status === "TROUVÉ" ? (
        <Box pb={5}>
            <BoxSelector />

            {/*<FormControl component="fieldset">
                <FormLabel component="legend">Mode de restitution</FormLabel>
                <FormGroup aria-label="position" row>
                    <FormControlLabel
                        value="start"
                        control={<Checkbox />}
                        label="Par livraison"
                        labelPlacement="start"
                    />
                    <FormControlLabel
                        value="bottom"
                        control={<Checkbox />}
                        label="En main propre"
                        labelPlacement="start"
                    />
                </FormGroup>
              </FormControl>*/}
        </Box>
      ) : (
        <Typography variant="h5">
          Pas de Stockage pour les Objets Perdus
        </Typography>
      )
     }
     
      {isBoxSelected && (
        <Box display="flex" flexDirection="column" alignItems="center" gap={2} mt={4}>
          {/* Indicateur de progression pour l'upload */}
          {isSubmitting && (
            <Box sx={{ width: '100%', maxWidth: 400, mb: 2 }}>
              <Typography variant="body2" color="text.secondary" gutterBottom align="center">
                Publication en cours...
              </Typography>
              <LinearProgress 
                variant="determinate" 
                value={uploadProgress} 
                sx={{ 
                  height: 8, 
                  borderRadius: 4,
                  backgroundColor: '#e0e0e0',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: '#22c55e',
                  }
                }} 
              />
              <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block', textAlign: 'center' }}>
                {uploadProgress}% terminé
              </Typography>
            </Box>
          )}
          
          {/* Message de confirmation quand la publication est réussie */}
          {isPublished && !isSubmitting && (
            <Box sx={{ width: '100%', maxWidth: 400, mb: 2 }}>
              <Typography variant="body2" color="success.main" gutterBottom align="center" sx={{ fontWeight: 'bold' }}>
                ✅ Publication réussie !
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center' }}>
                Redirection en cours...
              </Typography>
            </Box>
          )}
          
          <Box display="flex" justifyContent="center" gap={2}>
            <Button
              variant="outlined"
              color="error"
              onClick={handleCancelClick}
              disabled={isSubmitting || isPublished}
              sx={{
                borderColor: (isSubmitting || isPublished) ? '#9ca3af' : '#ef4444',
                color: (isSubmitting || isPublished) ? '#9ca3af' : '#ef4444',
                '&:hover': {
                  borderColor: (isSubmitting || isPublished) ? '#9ca3af' : '#dc2626',
                  backgroundColor: (isSubmitting || isPublished) ? '#f9fafb' : '#fef2f2',
                },
                px: 4,
                py: 1.5,
                fontSize: '1.1rem',
                fontWeight: 'bold',
              }}
            >
              Annuler la publication
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handlePublish}
              disabled={isSubmitting || isPublished}
              startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
              sx={{
                backgroundColor: (isSubmitting || isPublished) ? '#9ca3af' : '#22c55e',
                '&:hover': {
                  backgroundColor: (isSubmitting || isPublished) ? '#9ca3af' : '#16a34a',
                },
                px: 4,
                py: 1.5,
                fontSize: '1.1rem',
                fontWeight: 'bold',
                cursor: (isSubmitting || isPublished) ? 'not-allowed' : 'pointer',
                pointerEvents: (isSubmitting || isPublished) ? 'none' : 'auto',
              }}
            >
              {isSubmitting ? 'Publication en cours...' : 
               isPublished ? 'Publication réussie !' : 'Publiez votre annonce'}
            </Button>
          </Box>
        </Box>
      )}

      {/* Dialogue de confirmation pour l'annulation */}
      <Dialog
        open={showCancelDialog}
        onClose={handleCancelClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ 
          backgroundColor: '#fef2f2', 
          color: '#dc2626',
          borderBottom: '1px solid #fecaca'
        }}>
          Confirmer l'annulation
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Typography variant="body1" color="text.primary">
            Êtes-vous sûr de vouloir annuler la publication de votre annonce ?
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Toutes les données saisies seront supprimées et vous devrez recommencer depuis le début.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={handleCancelClose}
            variant="outlined"
            sx={{
              borderColor: '#6b7280',
              color: '#6b7280',
              '&:hover': {
                borderColor: '#4b5563',
                backgroundColor: '#f9fafb',
              },
            }}
          >
            Continuer la publication
          </Button>
          <Button
            onClick={handleCancelConfirm}
            variant="contained"
            color="error"
            sx={{
              backgroundColor: '#ef4444',
              '&:hover': {
                backgroundColor: '#dc2626',
              },
            }}
          >
            Annuler définitivement
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
